import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import PreferencesMenuView from './PreferencesMenuView';
import PaneSelector from './PaneSelector';
import { FOCUSABLE_BUT_NOT_TABBABLE } from '@/Constants/Constants';
const PreferencesCanvas = (props) => (_jsxs("div", { className: "flex min-h-0 flex-grow flex-col md:flex-row md:justify-between", children: [_jsx(PreferencesMenuView, { menu: props.menu }), _jsx("div", { className: "min-h-0 flex-grow overflow-auto bg-[--preferences-background-color]", tabIndex: FOCUSABLE_BUT_NOT_TABBABLE, children: _jsx(PaneSelector, { ...props }) })] }));
export default observer(PreferencesCanvas);
